import styled from "styled-components";

export const CardContentContainer = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  height: 100%;
`;

export const ImageLarge = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 1;

  p {
    margin: 0;
    padding: 0;
    font-size: 1.4rem;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-grow: 1;
    flex-shrink: 1;
  }

  line {
    fill: none;
    stroke-width: 1.5px;
    stroke: black;
  }

  svg {
    height: 28px;
    width: 28px;
  }

  &.half-width {
    p {
      font-size: 1.2rem;
    }

    svg {
      height: 20px;
      width: 20px;
    }
  }

  @media screen and (max-height: 750px) {
    padding: 4px;
  }
`;

export const TitleWithImageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 1;
  flex-grow: 1;
  overflow: hidden;

  .image {
    height: 30px;
    width: 30px;
    overflow: hidden;
    border-radius: 18px;
    flex: 0 0 30px;
  }

  &.half-width {
    gap: 3px;
    .image {
      height: 22px;
      width: 22px;
      flex-basis: 22px;
    }
  }

  @media screen and (max-height: 750px) {
    .image {
      height: 20px;
      width: 20px;
      flex-basis: 20px;
      border-radius: 18px;
    }

    &.half-width {
      .image {
        height: 16px;
        width: 16px;
        flex-basis: 16px;
      }
    }
  }
`;
